var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-container" }, [
    _vm.iframeUrl
      ? _c("iframe", {
          attrs: { src: _vm.iframeUrl, id: "mapIframe", frameborder: "0" },
          on: { load: _vm.onIframeLoaded, error: _vm.onIframeError },
        })
      : _c("div", { staticClass: "error-message" }, [
          _vm._v("缺少运单号，无法加载地图"),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }